export default "__VITE_ASSET__BCg9VN1G__"